import { Component } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { Platform } from '@ionic/angular';
import { AuthService } from './auth/auth.service';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { PushNotificationService } from './push-notification.service';
import { DataService } from './sharedFiles/data.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  constructor( private platform: Platform,
                private splashScreen: SplashScreen,
                private authService:AuthService,
                private statusBar: StatusBar,
                private pushNotificationService:PushNotificationService,
                private dataService:DataService) {
    this.initializeApp();
  }

  initializeApp(){
    console.log("came to intialize app")
    if(Capacitor.getPlatform() === 'web'){
     this.authService.appPlatform = 'web';
     //this.authService.appPlatform = 'ios';
    }else if(Capacitor.getPlatform() === 'ios'){
      this.authService.appPlatform = 'ios';
      this._cordavaCommands();
      this.authService.loginBasedOnDevice(true);
    }else{
      this.authService.appPlatform = 'android';
      this._cordavaCommands();
      this.authService.loginBasedOnDevice(true);
    }
    this.authService.initiateChatConnection.subscribe(data =>{
      this.dataService.connectToChatServer(this.authService.username);
    });
  }

  private _cordavaCommands(){
    this.platform.ready().then(() => {
      this.statusBar.overlaysWebView(true);
      this.statusBar.backgroundColorByHexString("#ffffff");
      this.statusBar.styleDefault();
      this.splashScreen.hide();
      this.pushNotificationService.initPush();
    });
  }
}
